if (!customElements.get('collapsible-accordion')) {
  customElements.define('collapsible-accordion', class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('helloeoeoeoe')
      this.querySelectorAll('.accordion-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => this.toggleAccordion(toggle));
      });
    }

    toggleAccordion(toggle) {
      const content = toggle.nextElementSibling;
      const isActive = toggle.classList.contains('active');

      // Close all open accordions
      this.querySelectorAll('.accordion-content').forEach(div => {
        if (div !== content) {
          div.style.display = 'none';
          div.previousElementSibling.classList.remove('active');
        }
      });

      // Toggle the clicked accordion
      if (isActive) {
        content.style.display = 'none';
        toggle.classList.remove('active');
      } else {
        content.style.display = 'block';
        toggle.classList.add('active');
      }
    }
  });
}